'use client';

import { ReactNode } from 'react';
import { AuthProvider } from '../contexts/AuthContext';

export function Providers({ children }: { children: ReactNode }) {
  return <AuthProvider data-component-id="src/app/providers.tsx:7:9" data-component-path="src/app/providers.tsx" data-component-line="7" data-component-end-line="7" data-component-file="providers.tsx" data-component-name="AuthProvider" data-component-content="%7B%22elementName%22%3A%22AuthProvider%22%7D">{children}</AuthProvider>;
}
